export enum TradingTradersCommands {
  Traders = 'Traders',
}

export interface JsonTrader {
  name: string;
  id: number;
  /** Number of active accounts behind the trader; `0` for an empty one. */
  activeAccountsCount: number;
}

export interface JsonTradersResponse {
  command: TradingTradersCommands.Traders;
  list: JsonTrader[];
}
